import { memo, type PropsWithChildren, type ReactNode } from "react";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import type { WithSlots } from "types";
import { useCloseLoadingBackdropOverlay } from "ui/layouts/LoadingBackdropOverlay";
import type { StepSlots } from "../types";

type OnboardingCompleteProps = WithSlots<
    {},
    {},
    StepSlots & {
        readonly form: ReactNode;
    }
>;

const OnboardingComplete = ({ slots, children }: PropsWithChildren<OnboardingCompleteProps>) => {
    useCloseLoadingBackdropOverlay();

    return (
        <Card>
            <CardContent
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: 2
                }}
            >
                <Box>
                    <Typography
                        variant='h4'
                        sx={{
                            fontWeight: 600
                        }}
                    >
                        Your application is ready
                    </Typography>
                    <Typography
                        variant='body1'
                        sx={{
                            color: 'text.secondary',
                            mt: 2
                        }}
                    >
                        You’ve completed all the required steps — great work! Now it’s time to submit your information for review.
                    </Typography>
                    {slots?.form}
                    <Box
                        sx={{
                            mt: 3,
                            fontWeight: 600
                        }}
                    >
                        {slots?.stats}
                    </Box>
                </Box>
                <Box
                    sx={{
                        display: 'grid',
                        alignSelf: 'flex-start',
                        gap: 1,
                        position: 'relative',
                        '::before': {
                            content: '""',
                            position: 'absolute',
                            inset: 0,
                            width: '100%',
                            height: '100%',
                            bgcolor: 'transparent'
                        }
                    }}
                >
                    {children}
                </Box>
            </CardContent>
        </Card>
    );
};

export default memo(OnboardingComplete);
